/**
 * Switch statement.
 * @param cases A JSON object. Keys are the options, and the values are the function to call.
 *
 * Example calls:
 * 1. switch({'apple': () => eat(), 'orange': () => peel()})('')('apple')
 * 1a. This would return the 'eat' function.
 * 2. switch({'apple': () => eat(), 'orange': () => peel()})('')('grape')
 * 2a. This would return an empty string.
 */
export const switcher = (cases: any) => (defaultCase: any = () => null) => (key: any) =>
    cases.hasOwnProperty(key) ? cases[key] : defaultCase;

/**
 * @param f variable to check for function status and execute
 * @returns result of calling f or f itself
 */
export const exIfFunction = (f: any) => (f instanceof Function ? f() : f);

/**
 * Switch statement that also executes the found result.
 * @param cases
 */
export const fSwitch = (cases: any) => (defaultCase: any) => (key: any) =>
    exIfFunction(switcher(cases)(defaultCase)(key));
